"use strict";

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _transparentize = _interopRequireDefault(require("polished/lib/color/transparentize"));

var _useTheme2 = _interopRequireDefault(require("../../styles/useTheme"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var alpha45 = (0, _transparentize["default"])(0.55);
var alpha25 = (0, _transparentize["default"])(0.75);

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      fonts = _useTheme.fonts,
      spacing = _useTheme.spacing,
      colors = _useTheme.colors;

  return (0, _react.useMemo)(function () {
    return {
      root: _objectSpread({
        display: 'flex',
        boxSizing: 'content-box',
        minHeight: spacing(8),
        padding: spacing(0, 4),
        alignItems: 'center',
        outline: 'none',
        cursor: 'pointer',
        color: colors.scienceBlue,
        transition: 'background-color 150ms ease-in-out, color 150ms ease-in-out'
      }, fonts.primary, {
        '&[aria-disabled=true]': {
          cursor: 'auto',
          backgroundColor: (0, _transparentize["default"])(0.8)(colors.icon),
          color: colors.icon
        },
        '&[aria-selected=true]': {
          backgroundColor: alpha25(colors.anakiwa),
          fontWeight: 500
        },
        '&[data-focus=true]': {
          backgroundColor: alpha45(colors.anakiwa),
          fontWeight: 500
        },
        ':hover:not([aria-disabled="true"]), :focus:not([aria-disabled="true"])': {
          backgroundColor: alpha45(colors.anakiwa)
        }
      })
    };
  }, [fonts, spacing, colors]);
};

__signature__(useStyles, "useTheme{{ fonts, spacing, colors }}\nuseMemo{}", function () {
  return [_useTheme2["default"]];
});

var MenuItem = function MenuItem(props, ref) {
  var classes = useStyles();
  return (0, _core.jsx)("li", (0, _extends2["default"])({
    ref: ref,
    css: classes.root,
    tabIndex: 0,
    role: "option"
  }, props));
};

__signature__(MenuItem, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = (0, _react.forwardRef)(MenuItem);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(alpha45, "alpha45", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/MenuItem.tsx");
  reactHotLoader.register(alpha25, "alpha25", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/MenuItem.tsx");
  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/MenuItem.tsx");
  reactHotLoader.register(MenuItem, "MenuItem", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/MenuItem.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/PlacesAutocomplete/Menu/MenuItem.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();